import useToastedMutation from '../../../ReactQuery/useToastedMutation';
import { post } from '../../../redux/api';

async function reactivateUser(userId: number): Promise<void> {
  await post(`/api/internal-tools/user/${userId}/reactivate`, {});
}

export const useReactivateUser = (onSuccessCallback?: () => void) => {
  return useToastedMutation({
    mutationFn: reactivateUser,
    successToastMessage: (_data, userId) => `User ${userId} reactivated successfully`,
    errorToastMessage: (_error, userId) => `Failed to reactivate user ${userId}`,
    onSuccess: () => {
      onSuccessCallback?.();
    },
  });
};
